import React from 'react';
import { cardTheme } from '../../styles/cardTheme';
import toppersImage from '../../assets/images/teachers/68.jpg.jpeg';

const RepublicToppersSection: React.FC = () => (
  <section id="republic-toppers-section" className="scroll-mt-24" aria-labelledby="republic-toppers-heading">
    <div className="mb-6 max-w-2xl sm:mb-8">
      <div className="mb-3 flex items-center gap-2.5">
        <span className="inline-block h-5 w-1 shrink-0 rounded-full bg-gold-500" aria-hidden />
        <p className="text-sm font-semibold text-gold-700">تميز طلابنا</p>
      </div>
      <h2
        id="republic-toppers-heading"
        className={`text-[clamp(1.75rem,3.5vw,3rem)] font-bold leading-tight ${cardTheme.title}`}
      >
        أوائل الجمهورية
      </h2>
      <p className="mt-3 text-sm leading-relaxed text-green-900/70 sm:text-base">
        نفخر بطلابنا المتفوقين ونحتفي بنتائجهم
      </p>
    </div>

    <figure className="-mx-4 overflow-hidden sm:mx-0">
      <img
        src={toppersImage}
        alt="أوائل الجمهورية، طلاب نهج الأزهر المتفوقون"
        className="h-auto w-full object-contain"
        loading="lazy"
      />
    </figure>
  </section>
);

export default RepublicToppersSection;
